function initFaq() {

    if( !$('.faq_content').length ) {
        return;
    }

    console.log('initFaq');

    $('.faq_content h2').on('click', function(e){
        $('.faq_content h3').hide();
        $('.faq_content p, .faq_content ul').hide();

        // $(this).nextAll('h3').show();

        var showNextElement = true;
        var currentElement = $(this);
        while (showNextElement) {
            currentElement = currentElement.next();
            if( currentElement.is('h2') || currentElement.is('div') ) {
                showNextElement = false;
            }else if( currentElement.is('h3') ) {
                currentElement.show();
            }
        }
    });

    $('.faq_content h3').on('click', function(e){
        $('.faq_content p, .faq_content ul').hide();

        //$(this).nextAll('p').show();
        var showNextElement = true;
        var currentElement = $(this);
        while (showNextElement) {
            currentElement = currentElement.next();
            if( currentElement.is('h2') || currentElement.is('h3') || currentElement.is('div') ) {
                showNextElement = false;
            }else if( currentElement.is('p') || currentElement.is('ul') ) {
                currentElement.show();
            }
        }

    });

}

module.exports = initFaq;


// WEBPACK FOOTER //
// ./js/faq.js